// ─── Ant Design button prop overrides ─────────────────────────────────────────
// Defined here as named constants so there are no anonymous objects in JSX.
import { SB_COLORS } from "theme/SbThemeV2";

export const WARNING_MODAL_OK_BUTTON_PROPS = {
  style: { background: SB_COLORS.primary, borderColor: SB_COLORS.primary },
};

export const CONDITIONAL_MODAL_CANCEL_BUTTON_PROPS = {
  style: { display: "none" },
};
